import { useFormikContext } from 'formik';
import { useEffect } from 'react';

import { useAppDispatch } from 'store';
import { type FormSections } from 'store/intakeForm/intakeFormSchema';
import { updateCapturedData } from 'store/intakeForm/intakeFormSlice';

interface CapturedDataListenerProps {
    section: (typeof FormSections)[keyof typeof FormSections];
    isOpen: boolean;
}

/** Stores form data in redux as the user enters it */
export const CapturedDataListener = ({ section, isOpen }: CapturedDataListenerProps) => {
    const dispatch = useAppDispatch();
    const { values, isSubmitting } = useFormikContext();
    useEffect(() => {
        if (isOpen && !isSubmitting) {
            dispatch(updateCapturedData({ [section]: values }));
        }
    }, [values, section, isOpen, isSubmitting, dispatch]);
    return null;
};
